import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {FormikContextType, useFormikContext} from 'formik';
import {BottomSheet} from 'react-spring-bottom-sheet';
import useGetInitialSponsorInformation from '../../../../../services/hookService/sponsor/getInitialSponsorInformation/useGetInitialSponsorInformation';
import {initialValuesSponsorForm} from '../../../CreateActivePlan/type';
import SponsorCustomButton from '../../CustomButton';
import {SponsorBottomSheetProps} from '../type';

const ProductTypeBottomSheet = ({show, setShow}: SponsorBottomSheetProps) => {
  const {sponsorInfo, isLoading} = useGetInitialSponsorInformation();
  const formikProps: FormikContextType<initialValuesSponsorForm> =
    useFormikContext();

  return (
    <BottomSheet
      onDismiss={() => setShow(false)}
      open={show}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
      className="custom-bottom-sheet"
    >
      <div className="p-6 flex flex-col gap-[29px] text-gray-900">
        {/* start header bottom sheet */}
        <div className="flex items-center justify-between ">
          <h5>محصولات</h5>
          <SpanIcon
            className="icon-nameClose-remove text-gray-700 text-2xl"
            onClick={() => setShow(false)}
          />
        </div>
        {/* end header bottom sheet */}
        <ul className="space-y-2 overflow-y-scroll mb-0 pl-0 max-h-[60dvh]">
          {!isLoading &&
            sponsorInfo?.products.map((product, index) => {
              const isInArray = formikProps.values.product.some(
                item => item.id === product.id,
              );
              return (
                <li
                  className="flex items-center gap-1"
                  key={'sponser-message-item' + index}
                  onClick={() => {
                    const newData = [...formikProps.values.product];
                    if (isInArray) {
                      formikProps.setFieldValue(
                        'product',
                        newData.filter(item => item.id !== product.id),
                      );
                    } else {
                      newData.push({title: product.title, id: product.id});
                      formikProps.setFieldValue('product', newData);
                    }
                    formikProps.setFieldTouched('product', true);
                  }}
                >
                  <input type="checkbox" className="mx-2" checked={isInArray} />
                  <span>{product.title}</span>
                </li>
              );
            })}
        </ul>
        <div className="px-8">
          <SponsorCustomButton
            outline={false}
            buttonType="button"
            title="تأیید"
            handler={() => setShow(false)}
          />
        </div>
      </div>
    </BottomSheet>
  );
};

export default ProductTypeBottomSheet;
